import moment from "moment";

type BenefitType = "S" | "I" | "IP" | "IT" | "J";
type RelationshipType = "T" | "C" | "H";
type GenderType = "M" | "F";

const BENEFIT_LABELS: Record<BenefitType, string> = {
  S: "Sobrevivencia",
  I: "Invalidez",
  IP: "Invalidez Parcial",
  IT: "Invalidez Total",
  J: "Jubilación",
};

const RELATIONSHIP_LABELS: Record<RelationshipType, string> = {
  T: "Titular",
  C: "Cónyuge",
  H: "Hijo",
};

const GENDER_LABELS: Record<GenderType, string> = {
  M: "Masculino",
  F: "Femenino",
};

export const formatDate = (dateString: string): string => {
  if (!dateString) return "-";
  return moment(dateString).format("DD/MM/YYYY");
};

export const getBenefitLabel = (benefit: string): string => {
  if (!benefit) return "-";
  return BENEFIT_LABELS[benefit as BenefitType] || "-";
};

export const getRelationshipLabel = (relationship: string): string => {
  if (!relationship) return "Beneficiario";
  return RELATIONSHIP_LABELS[relationship as RelationshipType] || "Beneficiario";
};

export const getGenderLabel = (gender: string): string => {
  if (!gender) return "-";
  return GENDER_LABELS[gender as GenderType] || "-";
};

export const getCurrencySymbol = (currency: string): string => {
  return currency && currency.includes("Dólares") ? "$ " : "S/ ";
};
